import styled from 'styled-components'

export const StepLabel = styled.label`
  display: grid;
  grid-template-columns: 0.1fr auto;
  grid-column-gap: 32px;
`

export const DescriptionLabel = styled.label`
  display: grid;
  grid-template-columns: 0.1fr auto;
  grid-column-gap: 32px;
`

export const Title = styled.h3`
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.colors.gray};
`
export const Buttons = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;

  button {
    width: 40%;
  }
`
